<template>
    <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-bold text-gray-500 uppercase text-nowrap"
    >
        <slot />
    </th>
</template>
